import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { phoneFormatter } from "@/core/phone";

type ContactProps = {
    details: MyBrokerApi.PersonalDetails;
};

const Contact: FC<ContactProps> = ({ details = {} }) => {
    const { t } = useTranslation();
    const emptyPhones = !(details.contact?.phone0 || details.contact?.phone1 || details.contact?.phone2);
    const emptyEmails = !(details.contact?.email0 || details.contact?.email1);

    return (
        <div>
            <div className="infoContainer">
                <span className="label">{t("Common.Phone")}</span>
                <div>
                    {emptyPhones && <p>-</p>}
                    {details.contact?.phone0 && <p>{phoneFormatter(details.contact.phone0)}</p>}
                    {details.contact?.phone1 && <p>{phoneFormatter(details.contact.phone1)}</p>}
                    {details.contact?.phone2 && <p>{phoneFormatter(details.contact.phone2)}</p>}
                </div>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.Email")}</span>
                <div>
                    {emptyEmails && <p>-</p>}
                    <p>{details.contact?.email0}</p>
                    <p>{details.contact?.email1}</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
